import { FiatCurrency } from '#src/__generated__/globalTypes.ts';
import { useCurrentUserCurrencies } from '#src/hooks/useCurrentUserCurrencies.tsx';

import eurImg from './assets/eur.webp';
import gpbImg from './assets/gpb.webp';
import usdImg from './assets/usd.webp';

const currencyIcons = {
  [FiatCurrency.USD]: usdImg,
  [FiatCurrency.GBP]: gpbImg,
  [FiatCurrency.EUR]: eurImg,
};

export const FiatWalletIcon = () => {
  const { fiatCurrency } = useCurrentUserCurrencies();
  return <img src={currencyIcons[fiatCurrency]} alt={fiatCurrency} />;
};
